
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { Image } from "antd";
import "../../css/HomeImage.css";

const API_URL =
    "https://api.github.com/repos/VuongMinh01/MinMedia-anh/contents/Home/HomeImages";

export default function HomeImage() {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        fetch(API_URL)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Không thể tải ảnh từ GitHub.");
                }
                return response.json();
            })
            .then((files) => {
                const imageFiles = files
                    .filter(
                        (file) =>
                            file.type === "file" &&
                            /\.(jpg|jpeg|png|webp|gif)$/i.test(file.name)
                    )
                    .sort((a, b) => a.name.localeCompare(b.name));

                setImages(imageFiles);
            })
            .catch((err) => setError(err.message))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return (
            <Container fluid className="text-center py-5">
                <Spinner animation="border" />
                <p>Đang tải ảnh...</p>
            </Container>
        );
    }

    if (error) {
        return <p className="text-center py-5">{error}</p>;
    }

    return (
        <Container fluid className="home-gallery">
            <Row>
                {images.map((img) => (
                    <Col
                        key={img.sha}
                        xs={12}
                        sm={6}
                        lg={4}
                        className="home-gallery-col"
                    >
                        <Image
                            src={img.download_url}
                            alt={img.name}
                            preview
                            width="100%"
                            className="home-gallery-image"
                        />
                    </Col>
                ))}
            </Row>
        </Container>
    );
}
